import React from 'react';
import { Check } from 'lucide-react';

const valueItems = [
  'Personalized software stack (4 tools)',
  'Plain-English rationale for each',
  'Avoid List (tools to skip)',
  'Growth timing guidance',
  'Upgrade path recommendations',
  'Instant access after purchase',
];

export function ValueList() {
  return (
    <div className="bg-gray-50 rounded-xl p-6">
      <h3 className="text-base font-semibold text-gray-900 mb-4">
        What you'll unlock:
      </h3>
      <ul className="space-y-3">
        {valueItems.map((item, index) => (
          <li key={index} className="flex items-start gap-3">
            <div className="flex-shrink-0 w-5 h-5 rounded-full bg-emerald-100 flex items-center justify-center mt-0.5">
              <Check className="w-3 h-3 text-emerald-600" />
            </div>
            <span className="text-sm text-gray-700">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
